import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "creation__container" }
const _hoisted_2 = { class: "creation__content-wrapper" }
const _hoisted_3 = { class: "creation__content text-center" }
const _hoisted_4 = { class: "mx-auto" }
const _hoisted_5 = { class: "creation__name text-creation-on-background" }
const _hoisted_6 = {
  key: 0,
  class: "pt-5"
}
const _hoisted_7 = { class: "creation__bubble" }
const _hoisted_8 = {
  key: 1,
  class: "creation__label text-creation-on-background"
}
const _hoisted_9 = {
  key: 2,
  class: "flex justify-center pt-2"
}
const _hoisted_10 = ["href", "target"]
const _hoisted_11 = {
  key: 0,
  class: "flex flex-col gap-6 px-4 text-center flex-grow-0 pb-2 w-full"
}
const _hoisted_12 = { class: "relative w-full" }
const _hoisted_13 = {
  key: 0,
  class: "relative flex justify-center text-xs"
}
const _hoisted_14 = { class: "p-4 rounded-xl flex flex-col gap-2 items-center justify-end bg-creation-on-background/creation-circle1 self-stretch" }
const _hoisted_15 = { class: "leading-6 text-creation-on-background text-opacity-creation-high text-sm" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("svg", { class: "icon button__icon stroke-2" }, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/assets/icons-v3.svg#link" })
], -1)
const _hoisted_17 = {
  key: 1,
  class: "button button--small button--primary"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("svg", { class: "icon button__icon stroke-[3]" }, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/assets/icons-v3.svg#check" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FullHeaderComponent = _resolveComponent("FullHeaderComponent")!
  const _component_FooterComponent = _resolveComponent("FooterComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_FullHeaderComponent, { campaign: _ctx.campaign }, null, 8, ["campaign"]),
          _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.campaign.profile.name || _ctx.campaign.profile.url), 1),
          (_ctx.campaign.successText)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.campaign.successText), 1)
              ]))
            : (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.$t('creation.defaultSuccessLabel')), 1)),
          (_ctx.shouldShowCTA)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("a", {
                  href: _ctx.campaign.successLink,
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.didOpenCTA && _ctx.didOpenCTA(...args))),
                  rel: "noreferrer noopener nofollow",
                  target: _ctx.target,
                  class: "button button--large shadow bg-creation-on-background text-creation-background"
                }, _toDisplayString(_ctx.ctaLabel), 9, _hoisted_10)
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    (_ctx.campaign.successShareEnabled)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            (_ctx.campaign.successLink && _ctx.campaign.successLinkLabel)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t('creation.askFriendLabel')), 1),
            (!_ctx.linkCopied)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.copyLink && _ctx.copyLink(...args))),
                  role: "button",
                  tabindex: "0",
                  class: "button button--small button--secondary"
                }, [
                  _hoisted_16,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('creation.copyLinkButtonLabel')), 1)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _hoisted_18,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('creation.copyLinkSuccessButtonLabel')), 1)
                ]))
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_FooterComponent, { campaign: _ctx.campaign }, null, 8, ["campaign"])
  ]))
}